import Moment from "moment-timezone";
import { extendMoment } from "moment-range";
import { ALL, THIS_WEEK, THIS_MONTH, LAST_WEEK, LAST_MONTH } from "../constant/filters";

const moment = extendMoment(Moment);

export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm A";
export const DATE_DATA_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_1 = "MM/DD/YYYY";
export const DATE_FORMAT_2 = "MMM D, YYYY";

export const isThisWeekDate = (date) => {
  const weekRange = moment().range(moment().startOf("week"), moment().endOf("week"));
  return weekRange.contains(moment(date));
};

export const isThisMonthDate = (date) => {
  const monthRange = moment().range(moment().startOf("month"), moment().endOf("month"));
  return monthRange.contains(moment(date));
};

export const isLastWeekDate = (date) => {
  const lastWeekRange = moment().range(
    moment().subtract(1, "week").startOf("week"),
    moment().subtract(1, "week").endOf("week")
  );
  return lastWeekRange.contains(moment(date));
};

export const isLastMonthDate = (date) => {
  const lastMonthRange = moment().range(
    moment().subtract(1, "month").startOf("month"),
    moment().subtract(1, "month").endOf("month")
  );
  return lastMonthRange.contains(moment(date));
};

export const isDateInRange = (timeRange, date) => {
  const range = moment().range(moment(timeRange.fromDate).startOf("day"), moment(timeRange.toDate).endOf("day"));
  return range.contains(moment(date));
};

export const inRange = (timeRange, date) => {
  switch (timeRange.fromDate) {
    case ALL:
      return true;
    case THIS_WEEK:
      return isThisWeekDate(date);
    case THIS_MONTH:
      return isThisMonthDate(date);
    case LAST_WEEK:
      return isLastWeekDate(date);
    case LAST_MONTH:
      return isLastMonthDate(date);
    default:
      return isDateInRange(timeRange, date);
  }
};

export const dateParser = (rawDate) => ({
  value: rawDate ? moment(rawDate) : rawDate
});

// Note: Use this when you want to display a datetime type - it will use local timezone.
export const dateTimeFormatter = (date, toFormat = DATE_TIME_FORMAT) => {
  const localTimeZoneDate = moment(date).local();
  return localTimeZoneDate.format(toFormat);
};

// Note: Use this when you want to display a date type only - since it will be with this format "YYYY-MM-DDT00:00:00.000Z" it will display wrong date if you use local time zone, the trick is to display UTC same as its.
export const dateFormatter = (date, toFormat = DATE_FORMAT) => {
  if (!date) return null;

  return moment(date).format(toFormat);
};
